import * as types from './mutation-types'
import orderApi from '../../endpoints/order'
import store from '@/store'

export const actions = {

    async createOrder({ commit, dispatch, getters, rootGetters }, payload) {

        commit(types.ORDER_CREATE_LOADING)

        const { data } = await orderApi.createOrder(payload)

        if (data.data.hcode === "ko") {
            commit(types.ORDER_CREATE_ERROR, { error: error, data: null })
            return
        }

        commit(types.ORDER_CREATE_COMPLETE, data.data.data)
        
        store.dispatch('cart/cartClean')

        return data
    },

    async getOrders({ commit, dispatch, getters, rootGetters }, payload) {

        //commit(types.GET_ORDERS_LOADING)

        const { data } = await orderApi.getOrders(payload)

        if (data.data.hcode === "ko") {
            commit(types.GET_ORDERS_ERROR, { error: error, data: null })
            return
        }

        commit(types.GET_ORDERS_COMPLETE, data.data.data.orders)    

        return data

    },


    async getOrder({ commit, dispatch, getters, rootGetters }, orderId) {

        commit(types.GET_ORDER_DETAIL_LOADING)

        const { data } = await orderApi.getOrder(orderId)

        if (data.data.hcode === "ko") {
            commit(types.GET_ORDER_DETAIL_ERROR, { error: error, data: null })
            return
        }

        commit(types.GET_ORDER_DETAIL_COMPLETE, data.data.data)    

        return data
    },

    async changeStatusOrder({ commit, dispatch, getters, rootGetters }, payload) {

        commit(types.CHANGE_STATUS_ORDER_LOADING)

        const { data } = await orderApi.changeStatusOrder(payload)

        if (data.data.hcode === "ko") {
            commit(types.CHANGE_STATUS_ORDER_ERROR, { error: error, data: null })
            return
        }

        commit(types.CHANGE_STATUS_ORDER_COMPLETE, data.data.data)
        
        return data
    },

    async createServicesOrder({ commit, dispatch, getters, rootGetters }, payload) {

        commit(types.ORDER_SERVICES_CREATE_LOADING)

        const { data } = await orderApi.createServicesOrder(payload)

        if (data.data.hcode === "ko") {
            commit(types.ORDER_SERVICES_CREATE_ERROR, { error: error, data: null })
            return
        }

        commit(types.ORDER_SERVICES_CREATE_COMPLETE, data.data.data)
        
        store.dispatch('cart/cartClean')

        return data
    },

    async getStripeClientSecretId({ commit, dispatch, getters, rootGetters }, payload) {

        commit(types.SET_STRIPE_CLIENT_SECRET_LOADING)

        const { data } = await orderApi.getStripeClientSecretId(payload)

        if (data.data.hcode === "ko") {
            commit(types.SET_STRIPE_CLIENT_SECRET_ERROR, { error: error, data: null })
            return
        }
 
        commit(types.SET_STRIPE_CLIENT_SECRET_COMPLETE, data.data)

        return data
    },

}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/order/actions.js
// module id = null
// module chunks = 